// @flow
import React from "react";
import { consts as uploaderConsts } from "uploader";
import { asAbsolute } from "root/routes/utils";
import DropBoxTab from "../index";
import dbConsts from "../data/consts";
import ContextItems from "../components/ContextItems";

const SRCS = uploaderConsts.SOURCES;

export default [{
	path: asAbsolute(SRCS.DROPBOX),
	component: DropBoxTab,
	routes: [
		{
			path: asAbsolute(SRCS.DROPBOX, "recent"),
			render: (props: Object) => <ContextItems
				context={dbConsts.CONTEXTS.RECENT} {...props} />,
		},
		{
			path: asAbsolute(SRCS.DROPBOX, "search"),
			render: (props: Object) => <ContextItems
				context={dbConsts.CONTEXTS.SEARCH} {...props} />,
		},
	],
}];
